import { Box, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'

import Button from '@/components/Button'
import Dialog from '@/components/Dialog'
import { useUpdateRecipeImageMutation } from '@/store/apiService'

interface ImageEditProps {
  open: boolean
  onClose: () => void
  initialData: {
    id: string
    note: string
  }
  refetchRecipe: () => void
}

function ImageEditContainer({
  open,
  onClose,
  initialData,
  refetchRecipe,
}: ImageEditProps) {
  const [form, setForm] = useState({
    note: '',
  })
  const [updateRecipeImage] = useUpdateRecipeImageMutation()

  useEffect(() => {
    if (initialData) {
      setForm({
        note: initialData.note || '',
      })
    }
  }, [initialData])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setForm((prev) => ({ ...prev, [name]: value }))
  }

  const isFormValid = Boolean(form.note)

  const handleSave = async () => {
    try {
      await updateRecipeImage({
        imageId: initialData.id,
        note: form.note,
      }).unwrap()
      toast.success('Note Updated successfully.')
      refetchRecipe()
      onClose()
    } catch (error) {
      toast.error('Unable to update notes.')
    }
  }

  return (
    <Dialog
      isOpen={open}
      onClose={onClose}
      title={
        <Typography fontSize={24} fontWeight={500}>
          Edit Note
        </Typography>
      }
      content={
        <Box display="flex" flexDirection="column" gap={2}>
          <TextField
            label="Note"
            name="note"
            value={form.note}
            onChange={handleChange}
            fullWidth
            variant="outlined"
            size="medium"
            multiline
            rows={4}
          />
        </Box>
      }
      actionButtons={
        <Box width="100%" gap={2} display="flex" justifyContent="flex-end">
          <Button label="CANCEL" onClick={onClose} variant="outlined" />
          <Button
            label="SAVE"
            onClick={handleSave}
            variant="contained"
            disabled={!isFormValid}
          />
        </Box>
      }
      paperStyles={{ width: '800px' }}
      triggerElement={undefined}
    />
  )
}

export default ImageEditContainer
